import { atom } from 'recoil';

import {
  defaultAuthenticationState,
  defaultLoadingState,
  defaultCurrentRmaState,
  defaultNotificationState,
  defaultInfoModalState,
  defaultLookupState,
  defaultAccountState,
  defaultCheckoutState,
  defaultCaseAssetsState,
} from './defaults';

export const authenticationState = atom({
  key: 'authenticationState',
  default: defaultAuthenticationState,
});

export const loadingState = atom({
  key: 'loadingState',
  default: defaultLoadingState,
});

export const currentRmaState = atom({
  key: 'currentRmaState',
  default: defaultCurrentRmaState,
});

export const notificationState = atom({
  key: 'notificationState',
  default: defaultNotificationState,
});

export const infoModalState = atom({
  key: 'infoModalState',
  default: defaultInfoModalState,
});

export const lookupState = atom({
  key: 'lookupState',
  default: defaultLookupState,
});

export const accountState = atom({
  key: 'accountState',
  default: defaultAccountState,
});

export const checkoutState = atom({
  key: 'checkoutState',
  default: defaultCheckoutState,
});

export const caseAssetsState = atom({
  key: 'caseAssetsState',
  default: defaultCaseAssetsState,
});
